import { ApiService } from 'app/core/services/apiservice';
import { Injectable } from '@angular/core';
import { Usuarios } from '../../../models/usuarios.model';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { CrearUsuarioModel } from 'app/models/crear-usuario.model';

@Injectable({providedIn: 'root'})
export class UsuariosService {
    constructor(
        private apiService: ApiService
    ) { }

    getUsuarios(){
        const url='/users'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los datos.')
                .subscribe((response: Usuarios) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    getTipologias(tipologiaId:number){
        const url=`/tipologias/${tipologiaId}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los tipologias.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    postUsuario(usurio:CrearUsuarioModel){
        const url= '/users/signup'
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, usurio, {}, 'Error al crear usuario')
                .subscribe(response=>{
                    resolve(true)
                }, error=>{
                    reject(true)
                })
        })

    }

    putUsuario(params: any){
        const url= '/users'
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, null, params, 'Error al crear usuario')
                .subscribe(response=>{
                    resolve(true)
                }, error=>{
                    reject(true)
                })
        })

    }

    
        
    
}